export default __webpack_public_path__ + "static/media/roboto-condensed-v18-latin-regular.8bbcf46f.svg";